<template>
  <cleave :class="classes" :value="value" @input="$emit('input', $event)" :options="opt" :placeholder="placeholder"></cleave>
</template>

<script>

export default {
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    classes: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultOptions: {
        phone: true,
        phoneRegionCode: 'CY'
      }
    };
  },
  computed: {
    opt() {
      return { ...this.defaultOptions, ...this.options };
    }
  },
};
</script>
